// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ef36848a","48":"c2ed3d7d","272":"2a8cd213","284":"beb1495f","358":"325dffaf","576":"92ab7ba6","693":"664cb3d3","940":"acd7b15c"}[chunkId] + ".chunk.js";
};